// src/features/templates/rejectedTemplatesSlice.ts
import { createSlice } from '@reduxjs/toolkit';

export interface RejectedTemplate {
  id: string;
  name: string;
  previewText: string;
  image: string;
  status: 'REJECTED';
  feedback: string;
  reviewer: string;
  avatar: string;
}

interface RejectedTemplatesState {
  templates: RejectedTemplate[];
}

const initialState: RejectedTemplatesState = {
  templates: [
    {
      id: '1',
      name: 'Template Name',
      previewText: 'Welcome Raj,\nGet book updates, directly and manage your loans - all through email.\nSimple, fast, right where you are.',
      image: 'https://via.placeholder.com/300x200?text=Laptop+in+Nature',
      status: 'REJECTED',
      feedback: `Overall, the template looks clean and well-structured. The hierarchy is clear, and the layout feels easy to scan, which is important for email readability. The header and hero section create a good first impression, and the CTA placement is intuitive.

Areas for improvement:
- The subject line preview and preheader could be optimized to feel more compelling and action-oriented.
- Body copy blocks feel slightly long; breaking them into shorter sections or adding subheadings could improve scannability.
- Consider increasing contrast slightly for secondary text to improve accessibility on mobile screens.
- The footer could be simplified—some information there feels repetitive.

Suggestions:
- Test the template in dark mode and across major email clients (Gmail, Outlook) to ensure consistency.
- Explore a secondary CTA style for less important actions.
- Add a bit more personality to the visual elements to better reflect the brand tone.

Overall:
A solid foundation with good visual clarity. With minor refinements in copy structure and accessibility, this template can perform very well in real campaigns.`,
      reviewer: 'Amy Denham',
      avatar: 'https://via.placeholder.com/32x32?text=A',
    },
    {
      id: '2',
      name: 'Template Name',
      previewText: 'Welcome Raj,\nGet book updates, directly and manage your loans - all through email.\nSimple, fast, right where you are.',
      image: 'https://via.placeholder.com/300x200?text=Laptop+in+Nature',
      status: 'REJECTED',
      feedback: `Overall, the template looks clean and well-structured. The hierarchy is clear, and the layout feels easy to scan, which is important for email readability. The header and hero section create a good first impression, and the CTA placement is intuitive.

Areas for improvement:
- The subject line preview and preheader could be optimized to feel more compelling and action-oriented.
- Body copy blocks feel slightly long; breaking them into shorter sections or adding subheadings could improve scannability.
- Consider increasing contrast slightly for secondary text to improve accessibility on mobile screens.
- The footer could be simplified—some information there feels repetitive.

Suggestions:
- Test the template in dark mode and across major email clients (Gmail, Outlook) to ensure consistency.
- Explore a secondary CTA style for less important actions.
- Add a bit more personality to the visual elements to better reflect the brand tone.

Overall:
A solid foundation with good visual clarity. With minor refinements in copy structure and accessibility, this template can perform very well in real campaigns.`,
      reviewer: 'Amy Denham',
      avatar: 'https://via.placeholder.com/32x32?text=A',
    },
    {
      id: '3',
      name: 'Template Name',
      previewText: 'Welcome Raj,\nGet book updates, directly and manage your loans - all through email.\nSimple, fast, right where you are.',
      image: 'https://via.placeholder.com/300x200?text=Laptop+in+Nature',
      status: 'REJECTED',
      feedback: `Overall, the template looks clean and well-structured. The hierarchy is clear, and the layout feels easy to scan, which is important for email readability. The header and hero section create a good first impression, and the CTA placement is intuitive.

Areas for improvement:
- The subject line preview and preheader could be optimized to feel more compelling and action-oriented.
- Body copy blocks feel slightly long; breaking them into shorter sections or adding subheadings could improve scannability.
- Consider increasing contrast slightly for secondary text to improve accessibility on mobile screens.
- The footer could be simplified—some information there feels repetitive.

Suggestions:
- Test the template in dark mode and across major email clients (Gmail, Outlook) to ensure consistency.
- Explore a secondary CTA style for less important actions.
- Add a bit more personality to the visual elements to better reflect the brand tone.

Overall:
A solid foundation with good visual clarity. With minor refinements in copy structure and accessibility, this template can perform very well in real campaigns.`,
      reviewer: 'Amy Denham',
      avatar: 'https://via.placeholder.com/32x32?text=A',
    },
  ],
};

const rejectedTemplatesSlice = createSlice({
  name: 'rejectedTemplates',
  initialState,
  reducers: {},
});

export default rejectedTemplatesSlice.reducer;